import { render } from "./VideoAction.vue?vue&type=template&id=0756dfa6&scoped=true&ts=true"
import script from "./VideoAction.vue?vue&type=script&lang=ts"
export * from "./VideoAction.vue?vue&type=script&lang=ts"

import "./VideoAction.vue?vue&type=style&index=0&id=0756dfa6&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0756dfa6"]])

export default __exports__